/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA all-reviews React view (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsAllRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.all',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsAllRoute);
